import React, { useEffect, useState } from "react";
import BuilderTabs from "../../Layouts/BuilderTabs";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { useTableContext } from "../../context/TableContext";
import BasicStyleEditor from "../BuilderComponents/BasicStyleEditor";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import FieldFormatSelection from "../BuilderComponents/FieldFormateSelection";
import { AddAndDeleteInlineIcon } from "../BuilderComponents/Preview/IconPreview";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import Input from "../FormComponents/Input";
import EditButtonGroup from "./EditButtonGroup";
import { InlineColorMasterdataSelection } from "./EditField";

const EditTableCell = ({
  editElementData,
  setEditElementData,
  tableId,
  data,
  appendExtraFilesAndFolders,
  device,
  elements
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tableRef, setTableRef] = useState(null);
  const { getTableTypeData } = useTableContext();

  const updateClassAndInlineStyleForCell = (classData, inlineData) => {
    const updatedData = { ...editElementData }; // Create a copy of the current state
    const cellData = updatedData.config.bodyData[data.row_index][data.col_index];

    // Update className and inline_style in the specific cell
    cellData.className = classData;
    cellData.inline_style = inlineData;

    setEditElementData(updatedData); // Update state
  };

  const callbackFunction = (data) => {
    handleChangeData(data.id, data.field_type || data.type);
    setIsModalOpen(false);
  };

  const handleChangeData = (data_key, data_type) => {
    const copy = JSON.parse(JSON.stringify(editElementData));
    copy.config.bodyData[data.row_index][data.col_index].data_key = data_key;
    copy.config.bodyData[data.row_index][data.col_index].data_type = data_type;
    setEditElementData(copy);
  };

  const handleHeaderData = (value) => {
    const copy = JSON.parse(JSON.stringify(editElementData));
    copy.config.headerData[data.header_index] = value;
    setEditElementData(copy);
  };
  const updateCellValue = (key, value) => {
    const copy = JSON.parse(JSON.stringify(editElementData));
    copy.config.bodyData[data.row_index][data.col_index][key] = value;
    setEditElementData(copy);
  };

  const deleteDataKey = (e) => {
    e.stopPropagation();
    const copy = JSON.parse(JSON.stringify(editElementData));
    copy.config.bodyData[data.row_index][data.col_index].data_key = "";
    copy.config.bodyData[data.row_index][data.col_index].data_type = "text";
    setEditElementData(copy);
  };

  const updateButtonGroupForCell = (paramsData) => {
    const copy = JSON.parse(JSON.stringify(editElementData));
    copy.config.bodyData[data.row_index][data.col_index] = paramsData;
    setEditElementData(copy);
  };
  let fieldType = "";
  let fieldFormat = "";
  if (data.cell_type === "body") {
    fieldType = editElementData.config.bodyData[data.row_index][data.col_index].data_type || "";
    fieldFormat = editElementData.config.bodyData[data.row_index][data.col_index].format || "";
  }
  let allTabs = [];
  if (data.cell_type === "body") {
    allTabs = [
      {
        label: "Data",
        content: (
          <div className="sidebar-edit-option-outer">
            <div className="flex_column gap_2">
              <div className="d_flex">
                <AddAndDeleteInlineIcon
                  icon={editElementData.config.bodyData[data.row_index][data.col_index]?.icon}
                  callbackFunction={(data) => updateCellValue("icon", data)}
                />
                <Input
                  value={editElementData.config.bodyData[data.row_index][data.col_index].data}
                  placeholder="Enter data"
                  inputClassName="border_left_none outline_none"
                  onChange={(e) => updateCellValue("data", e.target.value)}
                />
              </div>
              <span className="d_flex justify_center">or</span>
              <div onClick={() => setIsModalOpen(true)} className="builder_displayBox">
                {editElementData.config.bodyData[data.row_index][data.col_index].data_key && tableRef ? (
                  <>
                    {tableRef[editElementData.config.bodyData[data.row_index][data.col_index].data_key]?.display}
                    <ButtonActionIcon type="delete" onClick={deleteDataKey} />
                  </>
                ) : (
                  "Select Field"
                )}
              </div>
            </div>

            {fieldType === "number" && (
              <>
                <FieldFormatSelection
                  type="number"
                  value={fieldFormat}
                  onChange={(newValue) => updateCellValue("format", newValue)}
                />
                <FieldFormatSelection
                  type="currency"
                  value={editElementData?.currency_code || ""}
                  onChange={(newValue) => updateCellValue("currency_code", newValue)}
                  label="Currency Format"
                />
              </>
            )}
            {fieldType === "date" && (
              <FieldFormatSelection
                type="date"
                value={fieldFormat}
                onChange={(newValue) => updateCellValue("format", newValue)}
              />
            )}
            {fieldType === "time" && (
              <FieldFormatSelection
                type="time"
                value={fieldFormat}
                onChange={(newValue) => updateCellValue("format", newValue)}
              />
            )}
            {fieldType === "datetime" && (
              <FieldFormatSelection
                type="datetime"
                value={fieldFormat}
                onChange={(newValue) => updateCellValue("format", newValue)}
              />
            )}
            <InlineColorMasterdataSelection
              colorConfigType={editElementData.config.bodyData[data.row_index][data.col_index].color_config_type}
              handleEditElementData={(label, value) => updateCellValue(label, value)}
              colorMasterData={editElementData.config.bodyData[data.row_index][data.col_index].color_master_data || ""}
              colorIf={editElementData.config.bodyData[data.row_index][data.col_index].colorif || []}
            />

            <Input
              type="checkbox"
              label="Chips Format"
              name="show_chips"
              checked={editElementData.config.bodyData[data.row_index][data.col_index]?.show_chips}
              onChange={({ target }) => updateCellValue(target.name, target.checked)}
            />
          </div>
        )
      },
      {
        label: "Style",
        content: (
          <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ paddingTop: "0px" }}>
            <BasicStyleEditor
              value={{
                classData: editElementData.config.bodyData[data.row_index][data.col_index]?.className || {},
                inlineData: editElementData.config.bodyData[data.row_index][data.col_index]?.inline_style || {}
              }}
              callbackFunction={(data) => updateClassAndInlineStyleForCell(data.classData, data.inlineData)}
              fieldType={editElementData?.type || ""}
            />
          </div>
        )
      },
      {
        label: "Actions",
        content: (
          <EditButtonGroup
            editElementData={editElementData.config.bodyData[data.row_index][data.col_index]}
            setEditElementData={updateButtonGroupForCell}
            elements={elements}
            smId={tableId}
            device={device}
            places="details_view"
          />
        )
      }
    ];
  }

  useEffect(() => {
    const fetchTable = async () => {
      const { tableObject } = await getTableTypeData("statemachine", tableId);
      setTableRef({ ...tableObject, ...appendExtraFilesAndFolders.data });
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {data.cell_type === "header" && (
        <div className="p_3">
          <Input
            label="Enter Header Name"
            value={editElementData.config.headerData[data.header_index]}
            placeholder="Enter data"
            onChange={(e) => handleHeaderData(e.target.value)}
          />
        </div>
      )}
      {data.cell_type === "body" && <BuilderTabs tabs={allTabs} />}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Add Field">
        <TableTreeModal
          callbackFunction={callbackFunction}
          tableId={tableId}
          appendExtraFilesAndFolders={appendExtraFilesAndFolders}
          selectedFile={editElementData?.config?.bodyData?.[data?.row_index]?.[data?.col_index]?.data_key || ""}
        />
      </BuilderModal>
    </>
  );
};

export default EditTableCell;
